/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Method/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Method({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderMethod/Content/AddMethod/Content/Method",
  locationId,
  method,
  person,
  amount,
  onPaymentPageCallback,
  reusableForBluefin
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let paymentLocationIdValueData = fromData.useDataValue({ viewPath,
context: 'payment',
path: 'location_id',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(paymentLocationIdValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
 locationId={locationId}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
 method={method}
 person={person}
 amount={amount}
 onPaymentPageCallback={onPaymentPageCallback}
 reusableForBluefin={reusableForBluefin}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}